import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material';
import { VoucherService } from '@app/api/voucher.service';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'meu-modal-voucher',
  templateUrl: './modal-voucher.component.html',
  styleUrls: ['./modal-voucher.component.scss'],
})
export class ModalVoucherComponent implements OnInit {
  frmVoucher = new FormGroup({
    voucherValue: new FormControl('', [Validators.required]),
    quantity: new FormControl('', [Validators.required]),
    expiry: new FormControl('', [Validators.required]),
    note: new FormControl(''),
  });

  constructor(
    public dialogRef: MatDialogRef<ModalVoucherComponent>,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private voucherService: VoucherService
  ) {}

  ngOnInit() {}

  closeModal() {
    this.dialogRef.close();
  }

  submit() {
    const controls = this.frmVoucher.controls;
    if (this.frmVoucher.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }
    const voucherValue = this.frmVoucher.value.voucherValue.toString().replace(/\,/gi, '');
    const expiry: any = moment
      .utc(this.frmVoucher.value.expiry, 'DD/MM/YYYY')
      .add(23, 'hours')
      .add(59, 'minutes')
      .add(59, 'seconds')
      .toDate();
    this.voucherService
      .apiVouchersPost(
        voucherValue,
        this.frmVoucher.value.quantity,
        this.frmVoucher.value.note,
        expiry
      )
      .subscribe((res) => {
        if (res.success) {
          this.closeModal();
          this.toastr.success('Thao tác tạo mã giảm giá thành công');
        } else {
          this.toastr.error(res.message);
        }
      });
  }
}
